import React, { createContext, useContext, useState } from 'react';

import { Notification, NotificationContextType } from '@libs/types';

const NotificationContext = createContext<NotificationContextType | undefined>(
  undefined,
);

const DISPLAY_TIME = 4000;

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const addNotification = (message: string, type: Notification['type']) => {
    const id = crypto.randomUUID();

    setNotifications((prev) => [...prev, { id, message, type }]);

    setTimeout(() => removeNotification(id), DISPLAY_TIME);
  };

  const removeNotification = (id: string) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.id !== id),
    );
  };

  const context = { notifications, addNotification, removeNotification };

  return (
    <NotificationContext.Provider value={context}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = (): NotificationContextType => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      'useNotifications must be used within a NotificationProvider',
    );
  }
  return context;
};
